import { render } from "./MenuPrincipal.vue?vue&type=template&id=73d6aa00&scoped=true"
import script from "./MenuPrincipal.vue?vue&type=script&lang=js"
export * from "./MenuPrincipal.vue?vue&type=script&lang=js"

import "./MenuPrincipal.vue?vue&type=style&index=0&id=73d6aa00&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d6aa00"]])

export default __exports__